module.exports = __webpack_public_path__ + "img/cleaning-blue3.6df34e93.svg";